import { Card } from 'antd';
import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.white};
  min-height: 100vh;
  overflow: auto;
  padding: 16px 24px;

  @media (max-width: 1024px) {
    padding: 12px;
  }
`;

export const FiltersCard = styled(Card)`
  margin-bottom: 16px;
  border-radius: 8px;

  .options-row {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    margin-top: 8px;
  }

  .switch-label {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    user-select: none;
  }
`;

export const SummaryGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 8px;
  margin-bottom: 24px;
`;

export const SummaryCard = styled.div`
  background: linear-gradient(135deg, #1890ff 0%, #096dd9 100%);
  border-radius: 10px;
  padding: 18px 22px;
  color: white;
  min-width: 190px;
  flex: 1;
  max-width: 260px;
  box-shadow: 0 2px 10px rgba(24, 144, 255, 0.25);
  display: flex;
  flex-direction: column;
  gap: 2px;

  .year {
    font-size: 12px;
    opacity: 0.8;
    font-weight: 500;
    letter-spacing: 0.8px;
    text-transform: uppercase;
  }

  .avg {
    font-size: 34px;
    font-weight: 700;
    line-height: 1.15;
    margin-top: 2px;
  }

  .avg-label {
    font-size: 11px;
    opacity: 0.7;
    margin-bottom: 10px;
  }

  .counts {
    display: flex;
    gap: 14px;
    font-size: 12px;
    opacity: 0.9;
    flex-wrap: wrap;
    border-top: 1px solid rgba(255, 255, 255, 0.2);
    padding-top: 8px;
    margin-top: 4px;
  }
`;
